import { AssistantCitation } from '@services/modules/AssistantStream'
import { observer } from 'mobx-react'

import { openCitation } from './citationNavigation'
import { CitationPill, MetaRow } from './ui'

interface Props {
  citations: AssistantCitation[]
}

/**
 * Server-built citations only — deep links to the source records the answer's text does not
 * name itself (those are links in the text). Clicking opens the record in a dashboard tab (SPA
 * navigation, no reload).
 */
const CitationChips = ({ citations }: Props) => (
  <MetaRow>
    {citations.map(citation => (
      <CitationPill
        key={`${citation.type}-${citation.id}`}
        title="Open the source record"
        onClick={() => openCitation(citation)}
      >
        {citation.label}
      </CitationPill>
    ))}
  </MetaRow>
)

export default observer(CitationChips)
